export default ({ ...props }) => {
    const data = [{ url: "/", text: "Home" },
    { url: "/info-perusahaan", text: "Info Perusahaan" },
    { url: "/info-layanan", text: "Info Layanan" },
    { url: "/berita", text: "Berita" },
    { url: "/galeri", text: "Galeri" },
    { url: "/kontak", text: "Hubungi Kami" },
    {
        url: "#", text: "Link", subMenu: [
            { url: "/wbs", text: "Whistleblowing" },
        ]
    }]
    const activeMenu = props.activeMenu === '/detailBerita' ? '/berita' : props.activeMenu === '/wbs' ? '#' : props.activeMenu
    return (
        <div className="ml-auto">
            <ul className="navbar-nav">
                {data.map((item, key) => (
                    <li key={key} className={(item.url == activeMenu ? "active" : "") + (" nav-item position-relative d-flex align-items-center")} style={{ minHeight: "68px" }}>
                        <a className={"nav-link px-3"} href={item.url}>{item.text}</a>
                        {item.subMenu && (
                            <ul className="sub-menu">
                                {item.subMenu.map((subItem, subKey) => (
                                    <li key={subKey} className="d-flex">
                                        <a href={subItem.url}>{subItem.text}</a>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </li>
                ))}
                <li className="nav-item position-relative d-flex align-items-center">
                    <ul className="list-inline d-none d-xl-block">
                        <li className="list-inline-item"><a href="https://www.facebook.com/jasamargatollroadoperator/" target="_blank" className="d-block rounded-circle bg-white"><span className="icon-facebook"></span></a></li>
                        <li className="list-inline-item"><a href="https://www.instagram.com/jasamargatollroadoperator/" target="_blank" className="d-block rounded-circle bg-white"><span className="icon-instagram"></span></a></li>
                        {/* <li className="list-inline-item"><a className="d-block rounded-circle bg-white"><span className="icon-twitter"></span></a></li> */}
                    </ul>
                </li>
            </ul>
            <style jsx>
                {`
            @import './styles/jmto-custom';
            @media (max-width: 991.98px) {
                .navbar-nav {
                    height:100vh;
                    margin-top:15px;
                    margin-left:20px;
                    margin-right:20px;
                }
                .nav-item{
                    min-height:50px !important;
                }
                .nav-item a{
                    font-weight:700;
                }
                .nav-item a::after{
                    display:none;
                }
            }
            .nav-link {
                color: $white;
                font-size:.9em;
            }
            .nav-item a::after{
                content:'';
                position:absolute;
                bottom:0;
                left: 50%;
                right:0;
                width:0;
                height:10px;
                background-color:$white;
                transition: all ease-in-out .2s;
                
            }
            .nav-item:last-child{
                padding-left:10px;
                a::after{
                    background-color:transparent;
                }
                ul{
                    padding-left:22px;
                    border-left:1px solid $white;
                }
            }
            .nav-item:hover a::after,
            .nav-item.active a::after{
                width:100%;
                left: 0;
            }
            .list-inline-item a{
                width:25px;
                text-align:center;
                color:$blue;
                height:25px;

                span{
                    position:relative;
                    top:1px;
                    font-size:.8em;
                }
            }
            .sub-menu {
                padding: 0px;
                margin-top: 110px;
                display: none; /* Sembunyikan submenu secara default */
                position: absolute; /* Posisi absolut untuk dropdown */
                background-color: $blue; /* Warna latar belakang submenu */
                box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Bayangan untuk efek dropdown */
                z-index: 1000; /* Pastikan submenu di atas elemen lain */
            }
            .nav-item:hover .sub-menu {
                display: block; /* Tampilkan submenu saat hover pada item menu */
            }
            .sub-menu li {
                list-style: none;
                min-height: 40px; /* Tinggi minimum untuk item submenu */
            }
            .sub-menu a {
                padding: 10px 15px; /* Padding untuk item submenu */
                color: $white; /* Warna teks submenu */
                text-decoration: none; /* Hapus garis bawah */
            }
            .sub-menu a::after{
                background-color:$blue;
            }
            `}
            </style>
        </div>
    )
}